import type { ReactNode } from "react";

export interface FloatingTextareaProps {
  id: string;
  label: string;
  icon: ReactNode;
  value: string;
  onChange: (e: { target: { value: string } }) => void;
  rows?: number;
}

export function FloatingTextarea({
  id,
  label,
  icon,
  value,
  onChange,
  rows = 3,
}: FloatingTextareaProps) {
  return (
    <div className="floating-field relative">
      <textarea
        id={id}
        name={id}
        rows={rows}
        value={value}
        onChange={onChange}
        placeholder=" "
        className="block w-full resize-none rounded-xl border border-slate-200 bg-transparent px-4 pb-3 pt-5 text-sm text-slate-900 transition-colors duration-200 focus:border-[#2C78B9] focus:ring-0 focus:shadow-[0_0_0_3px_rgba(44,120,185,0.08)]"
      />
      <label
        htmlFor={id}
        className="inline-flex items-center gap-1.5"
      >
        <span className="w-3.5 h-3.5 flex items-center justify-center">
          {icon}
        </span>
        {label}
      </label>
    </div>
  );
}
